var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "Topic-title" }, [
      _vm._v("物模型通信 Topic 列表"),
    ]),
    _c(
      "div",
      [
        _c(
          "vxe-table",
          {
            attrs: {
              "row-id": "id",
              data: _vm.table,
              "sort-config": {
                defaultSort: { field: "function_type", order: "asc" },
              },
              align: "left",
            },
          },
          [
            _c("vxe-table-column", {
              attrs: {
                sortable: "",
                field: "function_type",
                "show-overflow": "",
                "min-width": "50",
                title: "功能",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "topic",
                "show-overflow": "",
                "min-width": "420",
                title: "Topic",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "topic_power",
                "show-overflow": "",
                "min-width": "80",
                title: "操作权限",
              },
            }),
            _c("vxe-table-column", {
              attrs: {
                field: "topic_desc",
                "show-overflow": "",
                "min-width": "220",
                title: "描述",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }